/**
 * Supabase project configuration.
 * 
 * Hardcoded to ensure the correct project is always used,
 * regardless of what the hosting platform injects as env vars.
 * These are public client-side values (anon key), not secrets.
 */
export const SUPABASE_URL = 'https://lkfaxfvyjcmsrdwvkrjk.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxrZmF4ZnZ5amNtc3Jkd3ZrcmprIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzMzUwNTYsImV4cCI6MjA3NTkxMTA1Nn0.KkCqBd-mVTY2fmlSZp1AcYU6Y2h0B5FnslVDSirA7MQ';

/**
 * Shared token the pre-sign-up onboarding funnel presents to the
 * `onboarding-chat` edge function via the `X-Onboarding-Secret` header (S10).
 *
 * This is sent from the browser, so — like the anon key above — it is NOT an
 * unguessable secret. Its job is to gate the GPT-4o-mini endpoint against
 * off-funnel scripted abuse (the S10 vector: rotate IPs, hammer the endpoint).
 * Combined with per-IP rate-limiting in the function, it raises attacker cost.
 * The matching value lives as the `ONBOARDING_SHARED_SECRET` Supabase secret.
 *
 * Override per-environment with VITE_ONBOARDING_SHARED_SECRET; the default keeps
 * the funnel working in local/preview builds where the env var is unset.
 */
export const ONBOARDING_SHARED_SECRET =
  (import.meta.env.VITE_ONBOARDING_SHARED_SECRET as string | undefined) ||
  'reprev-onboarding-funnel';
